<template>
    <flex-container
        class="email-editor-top-bar"
        :padding="Size.sm"
        align-items="center"
        justify-content="flex-end"
    >
        <button-text style="margin: 0 1rem" @click="emit('back')">
            <flex-container :gap="Size.sm" align-items="center">
                <svg-icon
                    :icon="IconChevronLeft"
                    :size="IconSize.sm"
                    is-custom-icon
                />
                <span>
                    <strong>Terug</strong>
                </span>
            </flex-container>
        </button-text>

        <div class="email-editor-top-bar__actions">
            <button-plain-icon
                v-tooltip="'Voorbeeld weergave'"
                :icon="IconFileMagnifyingGlass"
                :size="IconSize.md"
                is-custom-icon
                @click="emit('togglePreview')"
            />

            <button-plain-icon
                v-tooltip="'Verstuur test e-mail'"
                :icon="IconPaperPlaneTop"
                :size="IconSize.md"
                is-custom-icon
                @click="emit('sendTest')"
            />
        </div>

        <inline-edit-text
            v-model="subject"
        />

        <div style="flex-grow: 1" />

        <button-block @loading="save">
            Opslaan
        </button-block>
    </flex-container>
</template>

<script setup lang="ts">
    import {
        ButtonState,
        type ButtonStateChangedEvent,
        FlexContainer,
        IconSize,
        Size,
        SvgIcon,
        ButtonText,
        ButtonBlock,
        ButtonPlainIcon,
    } from '@keyvue/one-ui';

    import IconChevronLeft from '@keyvue/one-awesome-icons/icons/regular/chevron-left.svg?component';
    import IconFileMagnifyingGlass from '@keyvue/one-awesome-icons/icons/regular/file-magnifying-glass.svg?component';
    import IconPaperPlaneTop from '@keyvue/one-awesome-icons/icons/regular/paper-plane-top.svg?component';
    import InlineEditText from '@/flow/flow/components/InlineEditText.vue';
    import { ref, watch } from 'vue';

    const props = defineProps<{ subject: string }>();
    const subject = ref(props.subject);

    const emit = defineEmits<{
        (e: 'save'): void
        (e: 'back'): void
        (e: 'sendTest'): void
        (e: 'updateSubject', changedSubject: string): void
        (e: 'togglePreview'): void
        (e: 'toggleComments'): void
    }>();

    function save(event: ButtonStateChangedEvent) {
        emit('save');
        event.button.setState(ButtonState.completed);
    }

    watch(() => subject.value, (newValue) => emit('updateSubject', newValue));
</script>

<style scoped lang="scss">
.email-editor-top-bar {
    border-bottom: 1px solid color(gray-300);

    &__actions {
        display: flex;
        align-items: center;
        margin: 0 size(sm);

        > button {
            position: relative;

            &:before {
                position: absolute;
                inset: 0;
                content: '';
                border-left: 1px solid color(gray-300);
            }
            padding: 0 size(md);
        }
    }
}

.seperator {
    border-left: 1px solid color(gray-300);
    height: size(lg);
}
</style>
